import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import '../css/dataEntry.css';
import {Button} from "antd"; 

const DataEntry = ({ data }) => {
    
    const navigate = useNavigate();
    const { slug } = useParams();

    const handleShowDetails = (panelId, panelData) => {
        navigate(`/${slug}/details/${panelId}`, { state: { infoPanel: panelData } });
    };


    return (
        <div className="container">
            <div className="card-container">
                {data.infoPanel?.map((panel, index) => (
                    <div key={index} className="data-entry-card">
                        {panel.cardIcon && panel.cardIcon.data && (
                            <img
                                src={panel.cardIcon.data.attributes.url}
                                alt={panel.cardIcon.data.alternativeText || 'Icon'}
                                className="data-entry-icon"
                            />
                        )}
                        {panel.cardImage && panel.cardImage.data && (
                            <img
                                src={panel.cardImage.data.attributes.url}
                                alt={panel.cardImage.data.alternativeText || 'Image'}
                                className="data-entry-image"
                            />
                        )}
                        <div className="data-entry-content">
                            <h3>{panel.title || 'No Title'}</h3>
                            <p>{(panel.description[0]?.children[0].text.slice(0, 100) + '...') || 'No Description'}</p>
                            <Button
                                type={"link"}
                                className="detail-button"
                                onClick={() => handleShowDetails(panel.id, panel)}
                            >
                                Detaylar
                            </Button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );




};

export default DataEntry;
